import type { PageMeta } from '../../../lib/permissions/pageMeta'
import SalesReturnsPage from '../../sales/SalesReturnsPage'

export const pageMeta: PageMeta = {
  key: 'sell.returns',
  label: 'Sales Returns',
  module: 'Trading',
  section: 'Sell',
  description: 'Process customer returns',
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'edit',
    accountant: 'view', cashier: 'view', viewer: 'view',
  },
  hasVisibility: true,
  ownerColumn: 'created_by',
}

export default function SellReturnsTab() {
  return <SalesReturnsPage />
}
